import { normalizeCountrySelection } from 'candy-commons/utils/countrySelection';
import { normalizeShopifyCollectionHandle } from 'candy-commons/utils/shopifyCollectionHandle';
import COUNTRIES from '../../data/countries.json';
import BRANDS from '../../data/ecommerceBrandChoices.json';

const countryCodes = new Set(COUNTRIES.map(({ id }) => id));
const prefix = 'resources.ecommerce-special-initiatives';

export const countryChoices = COUNTRIES.map((country) =>
    country.id === 'ALL' ? { ...country, name: 'All countries' } : country
);

const isValidDate = (value) => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return false;
    }
    const date = new Date(`${value}T00:00:00.000Z`);
    return (
        Number.isFinite(date.getTime()) &&
        date.toISOString().slice(0, 10) === value
    );
};

export const validateSpecialInitiative = (values) => {
    const errors = {};
    if (!BRANDS.some(({ id }) => id === values.brand)) {
        errors.brand = 'ra.validation.required';
    }
    try {
        normalizeCountrySelection(values.countries, countryCodes);
    } catch (error) {
        errors.countries = `${prefix}.validation.${error.reason}`;
    }
    if (!normalizeShopifyCollectionHandle(values.collectionHandle)) {
        errors.collectionHandle = `${prefix}.validation.collectionHandle`;
    }
    for (const field of ['validFrom', 'validTo']) {
        if (!isValidDate(values[field])) {
            errors[field] = `${prefix}.validation.date`;
        }
    }
    if (
        !errors.validFrom &&
        !errors.validTo &&
        values.validTo < values.validFrom
    ) {
        errors.validTo = `${prefix}.validation.dateRange`;
    }
    return errors;
};

export const prepareSpecialInitiative = (values) => ({
    brand: values.brand,
    countries: normalizeCountrySelection(values.countries, countryCodes),
    collectionHandle: normalizeShopifyCollectionHandle(values.collectionHandle),
    validFrom: values.validFrom,
    validTo: values.validTo,
});
